import { useContext } from 'react'
import { utils } from '@digital-commerce/shared-utils'
import { object } from 'prop-types'

import localeContext from '../../../contexts/Locale'
import useTranslate from '../../../hooks/useTranslate'

import PriceBreakdownContainer from '../../molecules/CartItem/PriceBreakdown/PriceBreakdownContainer'
import ItemsPrice from '../../molecules/CartItem/PriceBreakdown/ItemsPrice'
import SubItems from '../../molecules/CartItem/PriceBreakdown/SubItems'
import FinalPrice from '../../molecules/CartItem/PriceBreakdown/FinalPrice'
import HeadingWithSubItems from '../../molecules/CartItem/PriceBreakdown/HeadingWithSubItems'

import { buildNonRecurringDiscounts, buildSubItemsData, buildTVExtrasData } from './utils'
import NameAndPrice from '../../atoms/ItemDetails/NameAndPrice'
import { buildHSGroupedRecurringDiscountList } from '../../../utils/discount'
import { buildHSCreditList } from '../../../utils/display'
import useCart from '../../../hooks/useCart'
import { OtherChargesAndCreditsContainer } from '../../molecules/CartItem/PriceBreakdown'

const { getMonthlyTotalPrice } = utils.cart

const OfferDetails = ({ pikTV }) => {
  const { cart } = useCart()
  const { lang } = useContext(localeContext)
  const translate = useTranslate()
  const finalPrice = getMonthlyTotalPrice(pikTV)?.subTotal

  const subItemsData = buildSubItemsData(pikTV, lang)
  const recurringDiscountsData = buildHSGroupedRecurringDiscountList(pikTV, lang, translate)
  const tvExtrasData = buildTVExtrasData(pikTV, lang)

  const creditsData = buildHSCreditList('tvx', cart, lang)
  const nonRecurringDiscountsData = buildNonRecurringDiscounts(pikTV, lang)

  const recurringDiscounts = recurringDiscountsData?.map(({ id, name, price, prefixIcon }) => (
    <NameAndPrice id={id} key={id} name={name} price={price} prefixIcon={prefixIcon} />
  ))

  const tvExtras = (
    <HeadingWithSubItems headingText={translate('extraChannels')} subItems={tvExtrasData} />
  )

  const creditsAndNonRecurringDiscounts = (
    <HeadingWithSubItems
      headingText={translate('additionalChargesAndCredits.additionalCreditsAndDiscounts')}
      subItems={[...nonRecurringDiscountsData, ...creditsData]}
    />
  )

  return (
    <>
      <PriceBreakdownContainer>
        <ItemsPrice items={[pikTV]} isRecurring />
        <SubItems items={subItemsData} />
        {recurringDiscounts}
        {tvExtras}
        <FinalPrice price={finalPrice} isMonthly />
      </PriceBreakdownContainer>
      <OtherChargesAndCreditsContainer listData={[...creditsData, ...nonRecurringDiscountsData]}>
        {creditsAndNonRecurringDiscounts}
      </OtherChargesAndCreditsContainer>
    </>
  )
}

export default OfferDetails

OfferDetails.propTypes = {
  pikTV: object.isRequired
}
